var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveShoorahPods(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 23.1667V16.5C28 14.0465 27.2637 11.765 26 9.86441M4 23.1667V16.5C4 9.87258 9.37258 4.5 16 4.5C17.9158 4.5 19.7267 4.94894 21.3333 5.74736",
    stroke: "#4A57DA",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3359 21.1641V23.8308",
    stroke: "#4A57DA",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66406 21.1641V23.8308",
    stroke: "#4A57DA",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 18.9595C10.6667 17.9403 10.6667 17.4307 10.4337 17.0764C10.3164 16.898 10.1608 16.7507 9.97919 16.646C9.61828 16.438 9.13083 16.4861 8.15592 16.5822C6.51316 16.7442 5.69178 16.8252 5.10316 17.2686C4.80526 17.493 4.55517 17.7791 4.36861 18.109C4 18.7607 4 19.6194 4 21.3368V23.4244C4 25.1247 4 25.9748 4.37597 26.6314C4.51669 26.8772 4.69308 27.0988 4.89888 27.2885C5.4487 27.7951 6.25125 27.9534 7.85636 28.2699C8.98592 28.4927 9.55069 28.6041 9.96752 28.3695C10.1213 28.2829 10.2573 28.1657 10.3676 28.0246C10.6667 27.642 10.6667 27.0437 10.6667 25.8472V18.9595Z",
    stroke: "#4A57DA",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3359 18.9595C21.3359 17.9403 21.3359 17.4307 21.5689 17.0764C21.6861 16.898 21.8417 16.7507 22.0234 16.646C22.3843 16.438 22.8717 16.4861 23.8466 16.5822C25.4894 16.7442 26.3108 16.8252 26.8994 17.2686C27.1973 17.493 27.4474 17.7791 27.6339 18.109C28.0026 18.7607 28.0026 19.6194 28.0026 21.3368V23.4244C28.0026 25.1247 28.0026 25.9748 27.6266 26.6314C27.4859 26.8772 27.3095 27.0988 27.1037 27.2885C26.5539 27.7951 25.7513 27.9534 24.1462 28.2699C23.0166 28.4927 22.4519 28.6041 22.035 28.3695C21.8812 28.2829 21.7453 28.1657 21.6349 28.0246C21.3359 27.642 21.3359 27.0437 21.3359 25.8472V18.9595Z",
    stroke: "#4A57DA",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveShoorahPods);
export default __webpack_public_path__ + "static/media/active-shoorah-pods.135784d42b9a215c1861ec075b912cde.svg";
export { ForwardRef as ReactComponent };